import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { SharedService } from "../shared.service";


export interface QrLifeCycleRequest {

 
  compId: number;
  fromDate?: string | null;
  toDate?: string | null;
  productId?: number;
  productNm?: string | null;
  productCd?: string | null;
  status?: string | null;
  search?: string | null;
  pageNo?: number;
  pageSize?: number;
}

export interface QrLifeCycleInsights {
  generatedQR: number;
  assignedQR: number;
  deallocatedQR: number;
  scrappedQR: number;
  availableQR: number;

  /** e.g. "Compared to Mar 5 - May 31, 2026" - built server-side, never hardcode this */
  comparePeriodLabel: string;
  fromDate: string;
  toDate: string;
  previousFromDate: string;
  previousToDate: string;

  generatedPercentage: number;
  assignedPercentage: number;
  deallocatedPercentage: number;
  scrappedPercentage: number;
  availablePercentage: number;

  generatedComparedToPrevious: number;
  assignedComparedToPrevious: number;
  deallocatedComparedToPrevious: number;
  scrappedComparedToPrevious: number;
  availableComparedToPrevious: number;
}

export interface QrLifeCycleTrendGraph {
  /** Raw "{0,4,10,}" strings straight off the SP - parse with parseTrendGraph() below if you need an array */
  generatedTrendGraph: string;
  assignedTrendGraph: string;
  deallocatedTrendGraph: string;
  availableTrendGraph: string;
  scrappedTrendGraph: string;
}

export interface QrLifeCycleReportItem {
  status: string;
  productId: number | null;
  productNm: string | null;
  productCd: string | null;

  fromNo: number;
  toNo: number;
  qty: number;
  mfgDt: string | null;
  expDt: string | null;
  batchNo: string | null;
  createdDt: string | null;
}

export interface QrLifeCycleResponse {
  insights: QrLifeCycleInsights;
  trendGraph: QrLifeCycleTrendGraph;
  data: QrLifeCycleReportItem[];
  pageNo: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
}

interface ApiResponse<T> {
  responseCode: string;
  responseMessage: string;
  details: T;
  errorDetails?: string;
}

/** Turns "{0,4,10,}" into [0,4,10]. */
export function parseTrendGraph(raw: string): number[] {
  if (!raw) return [];
  const cleaned = raw.trim().replace(/^\{/, "").replace(/\}$/, "").replace(/,$/, "");
  if (!cleaned) return [];
  return cleaned.split(",").map((v) => Number(v.trim()) || 0);
}

@Injectable({ providedIn: "root" })
export class QrLifeCycleService {
  url;

 

  constructor(private http: HttpClient, private sharedService: SharedService) { this.url = sharedService.baseURL; }

 
  getDashboard(request: QrLifeCycleRequest): Observable<QrLifeCycleResponse> {
    return this.http
      .post<ApiResponse<QrLifeCycleResponse>>(
        `${this.url}/api/Home/GetQRLifeCycleDashboard`,
        request,
      )
      .pipe(map((res) => res.details));
  }
}
